import * as icons from 'core/icons';

const maestros = {
    id: 'maestros',
    title: 'Maestros',
    type: 'group',
    collapse: false,
    visible: true,
    children: [
        /* {
            id: 'groupBodegas',
            title: 'Bodegas',
            type: 'collapse',
            icon: icons.BodegasIcon,
            visible: true,
            children: [
                {
                    id: 'bodegas',
                    title: 'Bodegas',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/bodegas',
                    icon: icons.BodegasIcon,
                    breadcrumbs: false
                },
                {
                    id: 'explotaciones',
                    title: 'Centros',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/centros',
                    icon: icons.SitesIcon,
                    breadcrumbs: false
                },
                {
                    id: 'marcas',
                    title: 'Marcas',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/marcas',
                    icon: icons.BrandsIcon,
                    breadcrumbs: false
                },
                {
                    id: 'etiquetasBodega',
                    title: 'Etiquetas',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/etiquetasbodega',
                    icon: icons.LabelsIcon,
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'groupViticultores',
            title: 'Viticultores',
            type: 'collapse',
            visible: true,
            icon: icons.ViticultoresIcon,
            children: [
                {
                    id: 'viticultores',
                    title: 'Viticultores',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/viticultores',
                    icon: icons.ViticultoresIcon,
                    breadcrumbs: false
                },
                {
                    id: 'parcelas',
                    title: 'Parcelas',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/parcelas',
                    icon: icons.ParcelIcon,
                    breadcrumbs: false
                }
            ]
        },*/
        {
            id: 'clientes',
            title: 'Clientes',
            type: 'item',
            url: '/maestros/clientes',
            visible: true,
            icon: icons.ClientesIcon,
            breadcrumbs: false
        },
        {
            id: 'proveedores',
            title: 'Proveedores',
            type: 'item',
            visible: true,
            url: '/gestion/maestros/Proveedores',
            icon: icons.ProveedoresIcon,
            breadcrumbs: false
        },
        {
            id: 'comerciales',
            title: 'Comerciales',
            type: 'item',
            visible: true,
            url: '/gestion/maestros/comerciales',
            icon: icons.ComercialesIcon,
            breadcrumbs: false
        },
        {
            id: 'usuarios',
            title: 'Usuarios',
            type: 'collapse',
            visible: true,
            icon: icons.UsuariosIcon,
            children: [
                {
                    id: 'usuarios',
                    title: 'Usuarios',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/usuarios',
                    icon: icons.UsuariosIcon,
                    breadcrumbs: false
                },
                {
                    id: 'logs',
                    title: 'Registro de accesos',
                    type: 'item',
                    visible: true,
                    url: '/gestion/maestros/logs',
                    icon: icons.LogIcon,
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default maestros;
